import { datadogRum } from '@datadog/browser-rum-slim';

export const Logger = {
  init: (releaseData: unknown) => {
    let releaseStage = 'production';
    let releaseVersion = 'unknown';
    if (typeof releaseData === 'object' && releaseData !== null) {
      if ('releaseStage' in releaseData) {
        releaseStage = releaseData.releaseStage as string;
      }
      if ('releaseVersion' in releaseData) {
        releaseVersion = releaseData.releaseVersion as string;
      }
    }
    
    datadogRum.init({ 
      applicationId: '39977a0d-2b4f-4db9-9538-06458889e422',
      /* cspell:disable-next-line */
      clientToken: 'pub8ce8d053c194b279fe6e49497fd53627',
      defaultPrivacyLevel: 'mask-user-input',
      env: releaseStage,
      service: 'conversations-admin-ui',
      sessionSampleRate: 100,
      
      /* cspell:disable-next-line */
      site: 'datadoghq.com',
      trackResources: true,
      trackUserInteractions: true,
      trackViewsManually: false,
      version: releaseVersion,
    });
  },

  user: (userData: { id: string; email: string; plan: string, name?: string }) => {
    datadogRum.setUser({
      id: userData.id,
      email: userData.email,
      plan: userData.plan,
      name: userData.name,
    });
  },

  record: () => {
    datadogRum.startSessionReplayRecording();
  },
  
  error: (error: Error, context?: object|undefined) => {
    datadogRum.addError(error, context);
  },
};

